import React from "react"
import {
    Box,
    useColors,
    Spacer,
    Divider,
    Orientation,
    componentStyles,
    ButtonGroup,
} from "@mallardbay/lib-react-components"

import ProfileButton from "~components/shared/header/profile-button"
import SidebarDrawerButton from "~components/shared/sidebar/sidebar-drawer-button"
import ResponsiveBlock from "~components/shared/responsive-block"
import {
    PAGE_HEADER_DIVIDER_HEIGHT,
    PAGE_HEADER_HEIGHT,
    TEST_IDS,
} from "~config/constants"
import CourierInbox from "~components/shared/courier-inbox"
import { useInAppBrowserContext } from "~contexts/in-app-browser-provider"
import { usePageLayout } from "~contexts/page-layout-provider"
import HelpMenuButton from "~components/shared/help-menu/help-menu-button"
import GlobalDashboardSearch, {
    MOBILE_SEARCHBAR_BREAKPOINT,
    useShouldShowGlobalSearch,
} from "~components/shared/header/global-dashboard-search"
import AssistantHeaderButton from "~components/outfitter-assistant/assistant-header-button"
import { ASSISTANT_HEADER_BUTTON_GAP } from "~components/outfitter-assistant/outfitter-assistant-constants"

export default function Header() {
    const styles = useStyles()
    const { isInAppBrowser } = useInAppBrowserContext()
    const { openSidebar } = usePageLayout()
    const shouldShowGlobalSearch = useShouldShowGlobalSearch()

    if (isInAppBrowser) {
        return null
    }

    return (
        <Box data-testid={TEST_IDS.PAGE_HEADER} style={styles.root}>
            <ResponsiveBlock>
                <Box style={styles.flexContainer}>
                    <SidebarDrawerButton onClick={openSidebar} />
                    {shouldShowGlobalSearch && (
                        <Box style={styles.searchContainer}>
                            <GlobalDashboardSearch />
                        </Box>
                    )}
                    <Spacer />
                    <Box style={styles.divider}>
                        <Divider orientation={Orientation.Vertical} />
                    </Box>
                    <ButtonGroup
                        display="flex"
                        alignItems="center"
                        gap={ASSISTANT_HEADER_BUTTON_GAP}
                    >
                        <CourierInbox />
                        <HelpMenuButton />
                        <ProfileButton />
                        <AssistantHeaderButton />
                    </ButtonGroup>
                </Box>
            </ResponsiveBlock>
            <Divider />
        </Box>
    )
}

function useStyles() {
    const colors = useColors()

    return componentStyles({
        root: {
            top: 0,
            width: "100%",
            position: "sticky",
            zIndex: 5,
            transition: "all .2s",
            bgColor: colors.bg,
        },
        flexContainer: {
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            py: 3,
            height: PAGE_HEADER_HEIGHT,
            gap: 4,
        },
        image: {
            boxSize: "44px",
            display: ["flex", "flex", "none"],
        },
        divider: {
            height: PAGE_HEADER_DIVIDER_HEIGHT,
            mx: 4,
        },
        searchContainer: {
            width: "100%",
            maxWidth: "500px",
            // Below the mobile breakpoint, GlobalDashboardSearch collapses to an
            // icon. Shrink the container to its content so it doesn't push the
            // right-side buttons across the row.
            [`@media (max-width: ${MOBILE_SEARCHBAR_BREAKPOINT})`]: {
                width: "auto",
            },
        },
    })
}
